import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import WatermarkImageListImagesScreen from "./WatermarkImageListImagesScreen";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function WatermarkImageMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Batch Watermark Images For Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/watermark_image", title: "Bulk Watermark Images Free" },
    data2: { link: "/watermark_image", title: "Protect Digital Pictures" },
    data3: { link: "/watermark_image", title: "Batch Watermark Images" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Batch watermark images online easily. Add text or logo watermarks to multiple images at once with our fast and secure image watermark tool."
      ></meta>
      <meta
        name="keywords"
        content="batch watermark images, bulk image watermark, add watermark to images, image watermark tool, watermark images online, batch image watermarking, bulk watermark photos, add logo to images, text watermark images, image branding tool, watermark photos in bulk, online image watermark, protect images online, image copyright tool, watermark images free, stamp images, image stamp tool, copyright images, copyright photos online, overlay text on image, overlay text on photo,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <WatermarkImageListImagesScreen
          title={title}
        ></WatermarkImageListImagesScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{
              "image/jpeg": [".jpg", ".jpeg"],
              "image/png": [".png"],
              "image/webp": [".webp"],
              "image/bmp": [".bmp"],
              "image/svg+sml": [".svg"],
            }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Batch Watermark Images website provides a fast, secure, and efficient solution for adding watermarks to multiple images at once without requiring an internet connection. Designed to work fully offline, this powerful tool allows users to protect photos directly on their device, ensuring complete privacy and data security. Whether you need to bulk watermark images for branding, copyright protection, or professional use, this platform makes it easy to add text or logo watermarks to large image collections in just a few clicks. Supporting popular formats like JPG, PNG, and WebP, the tool works as a reliable solution to watermark photos while preserving image quality. Users can also choose optional online functionality, making it flexible enough to act as a stamp images online tool when needed, while still offering the advantages of offline processing. With customizable options such as watermark position, opacity, size, rotation, and batch processing, this website is ideal for photographers, designers, businesses, and content creators. Optimized for speed and usability, it helps protect digital assets efficiently while improving workflow productivity. If you are looking for a secure batch watermark images tool, a fast way to bulk watermark images, or an easy to use solution to watermark photos with offline support, this website delivers a complete image protection solution." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Watermark",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Watermark Images"
            why_use={[
              {
                title: "Protect Image Copyright and Ownership",
                description:
                  "Our batch watermark images tool helps protect photos from unauthorized use by adding visible ownership marks. Using bulk watermark images ensures copyright protection across large image collections.",
              },
              {
                title: "Save Time with Bulk Processing",
                description:
                  "Our batch watermark images solution allows users to watermark photos in bulk, applying the same watermark to multiple images at once and saving significant time.",
              },
              {
                title: "Offline Watermarking for Privacy",
                description:
                  "This offline batch watermark images tool processes files directly on your device, keeping images private without uploading them to a stamp images online service.",
              },
              {
                title: "Maintain Brand Consistency",
                description:
                  "Using a bulk watermark images tool ensures consistent logos, text, and branding across all images, helping businesses maintain a professional visual identity.",
              },
              {
                title: "Preserve Image Quality",
                description:
                  "Advanced watermark photos tools apply watermarks without reducing image clarity, ensuring high-quality output even when processing images in batches.",
              },
              {
                title: "Ideal for Photographers and Creators",
                description:
                  "Photographers, designers, and content creators rely on batch watermark images tools to protect portfolios, client work, and social media content.",
              },
              {
                title: "Customizable Watermark Settings",
                description:
                  "Our bulk watermark images solution offers control over watermark size, opacity, position, and rotation, allowing users to customize how they watermark photos.",
              },
              {
                title: "Faster Content Publishing",
                description:
                  "Batch watermark images tools speed up workflows by preparing watermarked images quickly for websites, blogs, and social media platforms.",
              },
              {
                title: "Supports Multiple Image Formats",
                description:
                  "Our reliable batch watermark images tool supports JPG, PNG, WebP, and other formats, making it suitable for diverse image workflows.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I add a watermark to an image for free?",
                description:
                  "You can use ShivaPDF's Watermark Image tool to add a text or image watermark to your picture. Customize the watermark's position, size, and appearance, then save the watermarked image.",
              },
              {
                title: "Can I watermark images offline?",
                description:
                  "Yes, if the ShivaPDF Watermark Image tool is implemented to process images directly in your browser without requiring an internet connection after the page loads, you can add watermarks offline.",
              },
              {
                title: "Does ShivaPDF watermark images locally?",
                description:
                  "Local processing means your image is processed on your device instead of being sent to a remote server. Check the tool's implementation and network behavior to confirm that image processing stays local.",
              },
              {
                title: "Is the Watermark Image tool free to use?",
                description:
                  "ShivaPDF aims to make image tools accessible and easy to use. Check the Watermark Image page for any usage limits or restrictions that may apply.",
              },
              {
                title: "Can I add text as a watermark to an image?",
                description:
                  "Yes, a text watermark can display your name, brand, copyright notice, website address, or other identifying information on an image.",
              },
              {
                title: "Can I add a logo as an image watermark?",
                description:
                  "If image-watermark support is available, you can overlay your logo or another image on a picture to help identify its owner or promote your brand.",
              },
              {
                title: "Can I customize the watermark position?",
                description:
                  "Watermark positioning options let you place a watermark where it best suits your image, such as the center, a corner, or another supported position.",
              },
              {
                title: "Can I change the watermark size and transparency?",
                description:
                  "If supported by the tool, you can adjust the watermark's size and opacity to make it visible while keeping the important parts of the original image clear.",
              },
              {
                title: "Can I change the font and color of a text watermark?",
                description:
                  "Text watermark customization may include font style, font size, and color. Choose an appearance that remains readable against your image background.",
              },
              {
                title: "Which image formats can I watermark?",
                description:
                  "Supported image formats depend on the tool's implementation. Check the Watermark Image page for the available input and output formats, such as JPG, PNG, or WebP.",
              },
              {
                title: "Can I watermark JPG images?",
                description:
                  "If JPG is supported, you can add a text or logo watermark to a JPEG image and export the result in an available format.",
              },
              {
                title: "Can I watermark PNG images?",
                description:
                  "If PNG is supported, you can apply a watermark to a PNG image. PNG can also preserve transparency when the output settings and image content support it.",
              },
              {
                title: "Will watermarking reduce image quality?",
                description:
                  "Image quality can depend on the output format and compression settings. Choose suitable export settings to help preserve the original image's clarity.",
              },
              {
                title: "Can I add a copyright watermark to my photos?",
                description:
                  "Yes, a copyright watermark can include your name, brand, or copyright notice to communicate ownership and discourage unauthorized reuse. It cannot guarantee that an image will not be copied.",
              },
              {
                title: "Can I use a watermark to protect my photos online?",
                description:
                  "A visible watermark can help identify your work when photos are shared online. For stronger branding, use a consistent watermark that is difficult to crop out without affecting the image.",
              },
              {
                title: "Can I add a watermark to product images?",
                description:
                  "Watermarks can help businesses identify product photos with a brand name, logo, or website address. Make sure the watermark does not hide important product details.",
              },
              {
                title: "Can I watermark images for social media?",
                description:
                  "You can prepare watermarked images for social media when the tool supports your image format. A small, readable logo or brand name can help viewers recognize your content.",
              },
              {
                title: "Can I add a watermark without uploading my image?",
                description:
                  "If the tool processes images entirely in your browser, you may be able to add a watermark without uploading the image to a server. Verify that local processing is supported before relying on this privacy benefit.",
              },
              {
                title: "Are my images private when using ShivaPDF?",
                description:
                  "Privacy depends on how the tool handles image data. If privacy is a priority, use a verified local-processing mode and review the website's privacy policy.",
              },
              {
                title: "Can I use the watermark tool on a mobile phone?",
                description:
                  "If the tool is responsive and compatible with your mobile browser, you can watermark images from a supported smartphone or tablet without installing a separate app.",
              },
              {
                title: "Do I need to install software to watermark an image?",
                description:
                  "A browser-based watermark tool can let you edit images without installing desktop software. Internet access may still be needed to open the website, depending on offline support.",
              },
              {
                title: "Can I add multiple watermarks to one image?",
                description:
                  "Multiple watermarks can be useful for repeating a brand name or copyright notice across an image. This depends on whether the tool supports adding more than one watermark.",
              },
              {
                title: "How do I save an image after adding a watermark?",
                description:
                  "After customizing the watermark, use the tool's export or download option to save the processed image in a supported output format.",
              },
              {
                title: "What is the difference between a text watermark and a logo watermark?",
                description:
                  "A text watermark uses words such as a name, copyright notice, or website address. A logo watermark uses an image or brand symbol to identify the creator or business.",
              },
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1631645001}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default WatermarkImageMain;
